export default __webpack_public_path__ + "static/panacea-62479bd11e5e95cb7586196db117cd89.jpg";